
                export default function (Component) {
                    Component.__source = "library/layouts/VabLayoutFloat/index.vue"
                }
            